import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthProvider } from './contexts/AuthContext';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);

// Tapping a push notification while the app is already open: the service
// worker (public/push-sw.js) asks the page to navigate when it can't do it
// itself. Only same-origin targets are honoured.
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.addEventListener('message', (event) => {
    const { type, url } = event.data || {};
    if (type !== 'navigate' || typeof url !== 'string') return;
    const target = new URL(url, window.location.origin);
    if (target.origin === window.location.origin) window.location.assign(target.href);
  });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
